<template>
    <div>
        <v-btn v-if="isLoadingShown" text outlined block :style="buttonStyle" loading disabled data-testing="google-login-button"/>
        <div v-show="!isLoadingShown" class="google-button-container" ref="googleButtonContainer">
            <v-flex v-if="googleScriptShouldBeLoadedByNow" class="google-placeholder pa-2">
                <span>{{ $t('LOGIN_GOOGLE_PRIVACY_BLOCKER_TEXT') }}</span>
            </v-flex>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Ref } from 'vue-property-decorator';
import { TrackJS } from 'trackjs';
import { useErrorStore } from "@/stores/errorStore";
import { useApiClientStore } from "@/stores/apiClientStore";
import { useAuthenticationStore } from "@/stores/authenticationStore";

@Component({})
export default class GoogleSignInButton extends Vue {
    get isLoading() { return useApiClientStore().isLoading; }
    login = (payload: { provider: string, token: string }) => useAuthenticationStore().login(payload);
    @Prop(Function) onSignInSuccess: Function;
    @Prop(Array) scopes:string[];
    @Ref('googleButtonContainer') googleButtonContainer
    authInProgress: boolean = false;
    googleScriptShouldBeLoadedByNow = false;
    buttonRegistrationKey: symbol;

    get isLoadingShown()
    {
        return this.isLoading || this.authInProgress;
    }

    buttonStyle(): object {
        return {
            height: '48px',
            'background-color': 'white'
        }
    }

    created() {
        // Wait one second before displaying the privacy blocker default text
        setTimeout(() => this.googleScriptShouldBeLoadedByNow = true, 1000);
    }

    async mounted()
    {
        this.buttonRegistrationKey = await this.$google.registerButton(this.googleButtonContainer, this.defaultOnSignInSuccess, this.scopes);
    }

    async defaultOnSignInSuccess(user) {
        this.authInProgress = true;
        try
        {
            if (await this.login({ provider: "google", token: user.credential})) {
                this.$emit("confirm", user);
                useErrorStore().resetError();
            } else {
                useErrorStore().setError({ message: this.$t("LOGIN_UNABLE_TO_LOGIN_TEXT") });
            }
        }
        catch(e)
        {
            useErrorStore().setError(e);
            TrackJS.track(e);
        }
        finally 
        {
            this.authInProgress = false;
        }
    }
    beforeDestroy()
    {
        this.authInProgress = false;
        this.$google.deregisterButton(this.buttonRegistrationKey)
    }
}
</script>

<style scoped>
.google-placeholder {
    max-width: 320px;
    box-sizing: border-box;
    border-radius: 4px;
    border: thin dashed rgba(0, 0, 0, 0.2);
    font-family: "Google Sans", arial, sans-serif;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 1.25px;
    text-align: center;
}

.google-button-container /deep/ [role="button"]:hover {
    border-color: #e0e0e0;
    background-color: #f6f6f6;
}
.google-button-container /deep/ [role="button"]:focus {
    border-radius: 5px;
    box-shadow: 0 0 0 0.15rem #1867c0;
    background-color: #e4e4e4;
}
.google-button-container /deep/ [role="button"] > div {
    background: unset;
}

.google-button-container /deep/ [tabindex="0"]:empty {
    display: none;
}
.google-button-container /deep/ iframe {
    display: none !important;
}
</style>
